import React, { Component } from 'react';
import ExternalLink from '../asset/ExternalLink'

class CardFull extends Component {
  render(){
    return(
      <div className="container">
        <div className="col-1 extra-margin-bottom">
          <a href={this.props.pageUrl} target="_blank">
            <div className="bg-photo overlay hoverFeedack"  style={{backgroundImage: `url(${this.props.backgroundImage})`}}>
              <div className="hero hero--m hero__inner">
                <h1 className="shout weight-bold text-shadow">{this.props.title}</h1>
                <ul className="list-inline disciplines">
                <li>{this.props.tag} {ExternalLink}</li>
                </ul>
              </div>
           </div>
          </a>
      </div>
      </div>
    );
  }
}

export default CardFull;



// WEBPACK FOOTER //
// ./src/layout/CardFull.js